// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"F1-z"};